import moment from "moment/moment";
import Status from "../UI/Status";

interface LaposteFile {
  id_laposte?: number | null;
  laposte_delivered_at?: string | null;
}

interface LaposteStatusIndicatorProps {
  file?: LaposteFile | null;
}

export default function LaposteStatusIndicator({
  file,
}: LaposteStatusIndicatorProps) {
  if (!file || !file.id_laposte) return null;

  if (file.laposte_delivered_at) {
    return (
      <Status
        color="success"
        text={`Recommandé livré le ${moment(file.laposte_delivered_at).format(
          "DD/MM/YYYY",
        )}`}
      />
    );
  }

  return <Status color="warning" text={`Recommandé N°${file.id_laposte}`} />;
}
